import type { JSX } from 'react'
import type { ILabelProps } from '../Label'

import { COLOR } from 'vars/index'
import { Label } from '../Label'
import { Backgrounds, Corners, Fonts, LabelsOrder, Paddings } from '../Label.h'

export type ILabelAgeRatingProps = ILabelProps

export const LabelAgeRating = ({
  title = '',
  background = Backgrounds.SURFACE_OPACITY_DARK_60,
  padding = Paddings.SIZE_90,
  font = Fonts.FontXsBold,
  color = COLOR.TEXT_ICON_PRIMARY,
  corners = Corners.CORNERS_10,
  order = LabelsOrder.ORDER_3,
  ...rest
}: ILabelAgeRatingProps): JSX.Element => (
  <Label
    title={title}
    background={background}
    padding={padding}
    font={font}
    color={color}
    corners={corners}
    order={order}
    {...rest}
  />
)
